function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import {
logger } from
'../logger/Logger';
import {
analyticsProvidersExtensions as extensions } from
'./providers/providersExtensions';

var STATES = {
  NOT_REGISTERED: 0,
  REGISTERING_ONLY: 1,
  REGISTERING_AND_OPTING_IN: 2,
  REGISTERED: 3,
  FAILED_TO_REGISTER: 4 };var


ViewerAnalytics = /*#__PURE__*/function () {
  function ViewerAnalytics() {var _this = this;_classCallCheck(this, ViewerAnalytics);
    this.providers = {};

    Object.keys(extensions).forEach(function (name) {
      _this.providers[name] = {
        instance: null,
        extensionId: extensions[name],
        state: STATES.NOT_REGISTERED,
        cache: [] };

    });
  }

  /**
     * @param {object} props - properties that are sent with every track request
     */_createClass(ViewerAnalytics, [{ key: "setSuperProps", value: function setSuperProps(
    props) {
      this.superProps = props;
    } }, { key: "register", value: function register()

    {var _this2 = this;var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';var callback = arguments.length > 1 ? arguments[1] : undefined;
      var providers = names === 'all' ? Object.keys(this.providers) : Array.isArray(names) ? names : [names];

      providers.forEach(function (name) {
        if (_this2.providers[name].state === STATES.REGISTERED) {
          logger.warn("Analytics provider '".concat(name, "' is already registered"));
          if (callback) {
            callback(name);
          }
        } else {
          if (!_this2.providers[name]) {
            throw new Error("Provider '".concat(name, "' has no extensions mapped to register"));
          }

          if (_this2.providers[name].state === STATES.REGISTERING_ONLY) {
            logger.warn("Analytics provider '".concat(name, "' is already being registered"));
            return;
          }

          if (!callback) {
            _this2.providers[name].state = STATES.REGISTERING_ONLY;
          }

          Autodesk.Viewing.theExtensionManager.downloadExtension(_this2.providers[name].extensionId).then(function (extension) {
            try {
              var provider = new extension.providerClass(extension.providerOptions);
              provider.init();

              if (_this2.superProps) {
                provider.register(_this2.superProps);
              }

              _this2.providers[name].instance = provider;

              if (callback) {
                callback(name);
              }

              _this2.providers[name].state = STATES.REGISTERED;
              logger.info("Analytics provider '".concat(provider.name, "' successfully registered"));


              if (_this2.providers[name].cache.length > 0) {
                _this2.providers[name].cache.forEach(function (data) {
                  _this2.providers[name].instance.track(data.event, data.properties);
                });

                _this2.providers[name].cache = [];
              }

            } catch (e) {
              _this2.providers[name].state = STATES.FAILED_TO_REGISTER;
              _this2.providers[name].cache = [];

              logger.error("Failed to register analytics provider: \"".concat(name, "\""), e);
            }
          });
        }
      });
    } }, { key: "optIn", value: function optIn(

    options) {var _this3 = this;var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
      var providersNames = names === 'all' ? Object.keys(this.providers) : Array.isArray(names) ? names : [names];

      providersNames.forEach(function (providerName) {
        logger.info("Trying to opt-in analytics provider '".concat(providerName, "'"));

        var registerProviderCallback = function registerProviderCallback(name) {
          if (_this3.providers[name].state === STATES.REGISTERING_AND_OPTING_IN) {
            _this3.providers[name].state = STATES.REGISTERED;
          }

          if (_this3.providers[name].state !== STATES.REGISTERED) {
            throw new Error("Analytics provider '".concat(name, "' can not be opted-in because is not registered"));
          } else if (_this3.providers[name].instance.hasOptedOut()) {
            _this3.providers[name].instance.optIn(options);
            logger.info("Analytics provider '".concat(name, "' opted-in"));
          } else {
            logger.warn("Analytics provider '".concat(name, "' is already opted-in"));
          }
        };

        if (!_this3.providers[providerName]) {
          throw new Error("No extension for '".concat(providerName, "' analytics available"));
        }

        switch (_this3.providers[providerName].state) {
          case STATES.REGISTERED: //Try to opt-in if is already loaded
            registerProviderCallback(providerName);
            break;

          case STATES.FAILED_TO_REGISTER:
            throw new Error("Can't opt-in '".concat(providerName, "' because registering failed"));

          case STATES.NOT_REGISTERED: //If is not registered, do that
          case STATES.REGISTERING_ONLY: //Is being registered by someone, but not trying to be opted-in, try to opt-in
            _this3.providers[providerName].state = STATES.REGISTERING_AND_OPTING_IN;
            _this3.register(providerName, registerProviderCallback);
            break;

          case STATES.REGISTERING_AND_OPTING_IN: //Already listening with a callback
          default:
            return;}

      });
    } }, { key: "optOut", value: function optOut(

    options) {var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
      this._getProviders(names).forEach(function (p) {return p.instance.optOut(options);});
    } }, { key: "hasOptedOut", value: function hasOptedOut(

    name) {
      this._checkUniqueProviderName(name);
      name = name.toLowerCase();

      var provider = this._getProviders(name)[0];
      return provider.instance.hasOptedOut();
    } }, { key: "getDistinctId", value: function getDistinctId(

    name) {
      this._checkUniqueProviderName(name);
      name = name.toLowerCase();

      var provider = this._getProviders(name)[0];
      return provider.instance.getDistinctId();
    } }, { key: "track", value: function track(

    event, properties) {var _this4 = this;var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
      var providerNames = names === 'all' ? Object.keys(this.providers) : Array.isArray(names) ? names : [names];

      providerNames.forEach(function (providerName) {

        if (!_this4.providers[providerName]) {
          throw new Error("Analytics provider '".concat(providerName, "' has no extension available to load"));
        } else if (_this4.providers[providerName].state === STATES.REGISTERED) {
          _this4.providers[providerName].instance.track(event, properties);
        } else if (_this4.providers[providerName].state === STATES.REGISTERING_ONLY) {
          var data = { //Data to track later
            event: event,
            properties: properties };


          _this4.providers[providerName].cache.push(data);
        } //STATES.UNLOADED or STATES.FAILED are ignored

      });
    } }, { key: "identify", value: function identify(

    distinctId) {var names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
      this._getProviders(names).forEach(function (p) {return p.instance.identify(distinctId);});
    } }, { key: "_checkUniqueProviderName", value: function _checkUniqueProviderName(

    name) {
      if (typeof name !== 'string' || name === '') {
        throw new Error("Analytics provider must be a registered non-empty string");
      } else if (name === 'all') {
        throw new Error("Analytics provider name cannot be 'all'");
      }
    } }, { key: "_getProviders", value: function _getProviders(

    names) {var _this5 = this;
      var keys;

      if (Array.isArray(names)) {
        keys = names.map(function (x) {return x.toLowerCase();});
      } else if (names === 'all') {
        keys = Object.keys(this.providers);
      } else {
        keys = [names.toLowerCase()];
      }

      keys.forEach(function (name) {

        if (!(name in _this5.providers)) {
          throw new Error("Analytics provider '".concat(name, "' has no extension to load"));
        } else if (_this5.providers[name].state === STATES.REGISTERING_ONLY) {
          throw new Error("Analytics provider '".concat(name, "' is being registered"));
        } else if (_this5.providers[name].state === STATES.NOT_REGISTERED) {
          throw new Error("Analytics provider '".concat(name, "' is not registered"));
        } else if (_this5.providers[name].state === STATES.FAILED_TO_REGISTER) {
          throw new Error("Analytics provider '".concat(name, "' could not be registered"));
        }

      });

      return keys.map(function (k) {return _this5.providers[k];});
    } }]);return ViewerAnalytics;}();


var instance = new ViewerAnalytics();
export {
instance as analytics };